import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon
} from 'reactstrap';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'

import IconSave from 'react-icons/lib/md/save';

import * as actions from '../actions/ticket';

import Select from 'react-select';

import {api, API_URL} from '../actions/_request';


const SubmitLoad = () => (
	<div className="p-2">
		<Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
	</div>
);

const procesos = [
    {label: 'Efectivo', value: 1},
    {label: 'Tarjeta Credito/Debito', value: 2},
    {label: 'Cheque', value: 3},
    {label: 'Credito', value : 4},
    {label: 'Transferencia', value : 5},
    {label: 'Produccion', value : 6}
];

const descuentos = [
    {label: '0%', value: 1},
    {label: '5%', value: 2},
    {label: '10%', value: 3},
    {label: '15%', value : 4},
    {label: '20%', value : 5}
];


class TicketModal extends React.Component
{
	constructor(props)
	{
		super(props)

		this.state = {
			ticketVenta: {
               tipo_pago  : 1,
               anexo_tipo_pago : '',

			},
            pago:0,
            cambio:0,
            action: 'save_ticket',
            descuento : 1,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
         this.handleInputCambio = this.handleInputCambio.bind(this);
        
	}

    componentWillReceiveProps(nextProps)
    {
        let {ticketVenta} = nextProps;
        let self = this;
        console.log("ticketVenta---->",ticketVenta);
        if(parseInt(ticketVenta.tipo_precios)==1){
            ticketVenta.tipo_pago=4;
            console.log("es a credito");
        }

        this.setState({
            ticketVenta : ticketVenta,
            pago:ticketVenta.total

        });

        ////console.log(this.state.ticketVenta)
    }

    handleInputChange(event) {
        let {ticketVenta} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        ticketVenta[name] = value;
        this.setState({
            ticketVenta : ticketVenta
        });
    }

    handleInputCambio(event) {
        let {ticketVenta,pago,cambio} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        if(parseInt(ticketVenta.total,10)<=parseInt(value,10))
        {
            cambio=parseInt(value,10)-parseInt(ticketVenta.total,10);
        }else
        {
            cambio=0;
        }
        pago=value;
        this.setState({
            pago : pago,
            cambio:cambio

        });
    }

    handleSelectChange(select, name) {

        const value = select === null ? null : select.value;

        this.setState({
            ticketVenta: {
                ...this.state.ticketVenta,
                [name]: value,
                anexo_tipo_pago : ''
            }
        });

        if(name === "cliente_id") {

            this.cliente = select;
        }

    }

    

	handleSubmit(evt)
	{
		evt.preventDefault();
		let {ticketVenta,pago} = this.state;
		var self = this;
        let error = false;
       
        let checkAnexo = false;
        let cambio = false;
         if(parseInt(ticketVenta.total,10)>parseInt(pago,10))
        {
            cambio=true;
        }
    
      
        

        
        
     

        if(ticketVenta['tipo_pago'] === 2 || ticketVenta['tipo_pago'] === 3){
            if(!ticketVenta['anexo_tipo_pago']){
                checkAnexo = true;
                error = true;
            }
        }

        console.log('ticket---->',ticketVenta);
               
        
        if(!error){
		this.props[this.props.action](ticketVenta, (id) => {
           
            if(this.props.action === 'save_ticket'){
            swal({
                title: 'Ticket',
                text: 'Ticket creado y pagado correctamente!',
                type: 'success',
                // showCancelButton: true,
                // confirmButtonColor: '#3085d6',
                // cancelButtonColor: '#d33',
                confirmButtonText: 'Continue!'
            }).then((result) => {
                if (result.value) {
                    // swal(
                    //  'Deleted!',
                    //  'Your file has been deleted.',
                    //  'success'
                    //  )
                    self.props.toggle();
                    self.props.history.push('/tickets/ver/'+id.id);
                    window.open(API_URL+"/ticketsv2/printTicketFinal/"+id.id);
                }
            })
        }else{
            if(id.pagado){
                swal('Bien hecho', 'El ticket se marco como pagado con éxito' ,'success').then((result) =>{
                    self.props.getticket(id.ticket);
                     self.props.toggle();
                     window.open(API_URL+"/ticketsv2/printTicketFinal/"+id.id);
                });
                
            }
            else if(id.proceso){
                
                swal('Error', 'El ticket ya esta marcado como pagado','error').then((result) =>{
                    self.props.toggle();
                });
            }
            else{
                swal('Error', 'El proceso no esta finalizado' ,'error').then((result) =>{
                    self.props.toggle();
                });
            }
        }
        });
        }
        else{
             if(checkAnexo){
                swal("Oops..", "Ingrese el anexo por favor", "error");
                return;
            }if(cambio)
            {
                swal("Oops..", "Ingrese una cantidad correcta Para Calcular El Cambio", "error");
                return;
            }
            

            
        }
	}

	render()
	{
		let {ticketVenta} = this.state;
        let etiqueta= ''; let tagPrecio =''
        let Temp ;
        let show = false;
        let total = 0;
        let precio = parseInt(ticketVenta.precio,10);
        let costo = parseInt(ticketVenta.costo,10);
        let incremento = parseInt(ticketVenta.incremento,10);
        let descuento = parseInt(ticketVenta.descuento,10);
        if(ticketVenta.tipo_id === 4){
            if(precio !== 0  && incremento !== 0){
                total = precio +  precio/100 * incremento;
            }
            else{
                total = precio;
            }
            tagPrecio = "Total";
        }else{
            tagPrecio = "Total"
            if(precio !== 0 && descuento !== 0){
                total = precio - precio/100 * descuento;
            }else{
                total = precio;
            }
        }
         
        if(ticketVenta.tipo_pago === 2){
            etiqueta = '4 Digitos';
            show = true;
        }else if(ticketVenta.tipo_pago === 3){
            etiqueta = 'No. cheque'
            show = true;
        }else if(ticketVenta.tipo_pago == 4){
            etiqueta = '';
            show = false;
        }
        else if(ticketVenta.tipo_pago == 5){
            etiqueta = 'Cuenta Bancaria/Clave Interbancaria';
            show = true;
        }
        else{
            etiqueta = '';
            show = false;
        }
		return(

			<Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg">
				<form onSubmit={this.handleSubmit}>
                <ModalHeader toggle={this.props.toggle}>Confirmar pago</ModalHeader>
                <ModalBody>{
                    <div className="row">
                        <div className="col-md-3">
                            <FormGroup>
                                <Label>{tagPrecio}</Label>
                                <InputGroup>
                                <InputGroupAddon>$</InputGroupAddon>
                                    <Input
                                    
                                    placeholder=""
                                    type="number"
                                    name="precio"
                                    value={ticketVenta.total}
                                    disabled
                                    />
                                </InputGroup>
                            </FormGroup>
                        </div>
                        {
                            parseInt( this.state.ticketVenta.tipo_pago)===1&&
                            <div className="col-md-3">
                            <FormGroup>
                                <Label>Pago</Label>
                                <InputGroup>
                                <InputGroupAddon>$</InputGroupAddon>
                                    <Input
                                    
                                    placeholder=""
                                    type="number"
                                    name="precio"
                                    value={this.state.pago}
                                    onChange={ this.handleInputCambio}
                                    />
                                </InputGroup>
                            </FormGroup>
                        </div>

                        }
                         {
                            this.state.ticketVenta.tipo_pago===1&&
                        <div className="col-md-3">
                            <FormGroup>
                                <Label>Cambio</Label>
                                <InputGroup>
                                <InputGroupAddon>$</InputGroupAddon>
                                    <Input
                                    disabled
                                    placeholder=""
                                    type="number"
                                    name="precio"
                                    value={this.state.cambio}                                   
                                    />
                                </InputGroup>
                            </FormGroup>
                        </div>
                    }
                        
                        
                        
                        
                        <div className="col-md-3">
                            <div className="form-group">
                                <label className>Tipo de pago:</label>
                                <Select
                                    placeholder=""
                                    type="text"
                                    name="tipo_pago"
                                    options={procesos}
                                    value={this.state.ticketVenta.tipo_pago}
                                    onChange={ (select) => { this.handleSelectChange(select, 'tipo_pago') } }
                                />
                            </div>
                        </div>
                        {
                            show &&
                             <div className="col-md-3">
                                <FormGroup>
                                    <Label>{etiqueta}</Label>
                                        <Input
                                        placeholder=""
                                        type="text"
                                        name="anexo_tipo_pago"
                                        value={this.state.ticketVenta.anexo_tipo_pago}
                                        onChange={ this.handleInputChange }
                                        />
                                </FormGroup>
                            </div>
                        }
                    </div>
                    }
                </ModalBody>
                <ModalFooter>
                    {
                    	this.props.ticket.saving ?
                    	<SubmitLoad /> : 
                    	<div>
                    		<Button color="primary" type="submit" >
                    			<IconSave />&nbsp;Pagar
                    		</Button>{' '}
                    		<Button color="secondary" onClick={this.props.toggle}>
		                    	Cancel
		                    </Button>
                    	</div>
                    }
                </ModalFooter>
                </form>
            </Modal>
		);
	}
}

function mapStateToProps(state, ownProps) {
    return {
        ticket : state.ticket,
    }
};

export default connect(mapStateToProps, actions)(TicketModal)


// WEBPACK FOOTER //
// ./src/components/modal.js